package com.sweetlime.bingeamigo.presentation.features.tvdetail

import androidx.compose.runtime.Composable
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.navigator.LocalNavigator
import cafe.adriel.voyager.navigator.currentOrThrow
import com.sweetlime.bingeamigo.model.TvShow

data class TvShowDetailScreen(
    val tvShowId: Int,
    val tvShowName: String,
    val tvShowOverview: String = "",
    val tvShowAdult: Boolean = false,
    val tvShowBackdropPath: String? = null,
    val tvShowPosterPath: String? = null,
    val tvShowOriginalLanguage: String = "",
    val tvShowOriginalName: String = "",
    val tvShowPopularity: Double = 0.0,
    val tvShowFirstAirDate: String = "",
    val tvShowVoteAverage: Double = 0.0,
    val tvShowVoteCount: Int = 0
) : Screen {

    @Composable
    override fun Content() {
        val navigator = LocalNavigator.currentOrThrow
        val tvShow = TvShow(
            id = tvShowId,
            name = tvShowName,
            overview = tvShowOverview,
            adult = tvShowAdult,
            backdropPath = tvShowBackdropPath,
            posterPath = tvShowPosterPath,
            originalLanguage = tvShowOriginalLanguage,
            originalName = tvShowOriginalName,
            popularity = tvShowPopularity,
            firstAirDate = tvShowFirstAirDate,
            voteAverage = tvShowVoteAverage,
            voteCount = tvShowVoteCount
        )
        TvShowDetailContent(
            tvShow = tvShow,
            onBackClick = { navigator.pop() },
            onSeasonClick = { season, posterFallback, totalEpisodes ->
                navigator.push(SeasonDetailScreen(tvShow, season, posterFallback, totalEpisodes))
            }
        )
    }
}

fun TvShowDetailScreen(tvShow: TvShow) = TvShowDetailScreen(
    tvShowId = tvShow.id,
    tvShowName = tvShow.name,
    tvShowOverview = tvShow.overview,
    tvShowAdult = tvShow.adult,
    tvShowBackdropPath = tvShow.backdropPath,
    tvShowPosterPath = tvShow.posterPath,
    tvShowOriginalLanguage = tvShow.originalLanguage,
    tvShowOriginalName = tvShow.originalName,
    tvShowPopularity = tvShow.popularity,
    tvShowFirstAirDate = tvShow.firstAirDate,
    tvShowVoteAverage = tvShow.voteAverage,
    tvShowVoteCount = tvShow.voteCount
)